import { website } from "../config/website";

export const getCanonicalUrl = (pagePath: string): string => (
  website.rootUrl + "/" + pagePath
)